import { AxiosError } from 'axios';
import { validateDataResponse } from '../../../commons/helpers';
import {
    callCreateTeamCalendarEvent,
    callCreateTeamCalendarShareLink,
    callDeleteTeamCalendarEvent,
    callDeleteTeamCalendarShareLink,
    callUpdateTeamCalendarEvent,
    retrievePublicTeamCalendar,
    retrieveTeamCalendarEventById,
    retrieveTeamCalendarEvents,
    retrieveTeamCalendarShareLinks
} from 'data/datasources/v1/TeamCalendar';
import {
    TeamCalendarEvent,
    TeamCalendarEventSearchRequest,
    TeamCalendarEventUpsertRequest,
    TeamCalendarPublicCalendarResponse,
    TeamCalendarShareLink,
    TeamCalendarShareLinkCreateRequest
} from 'data/schemas/TeamCalendar';

export async function getTeamCalendarEvents(
    params?: TeamCalendarEventSearchRequest
): Promise<TeamCalendarEvent[]> {
    try {
        const response = await retrieveTeamCalendarEvents(params);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getTeamCalendarEventById(id: string): Promise<TeamCalendarEvent> {
    try {
        const response = await retrieveTeamCalendarEventById(id);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function createTeamCalendarEvent(
    body: TeamCalendarEventUpsertRequest
): Promise<TeamCalendarEvent> {
    try {
        const response = await callCreateTeamCalendarEvent(body);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function updateTeamCalendarEvent(
    id: string,
    body: TeamCalendarEventUpsertRequest
): Promise<TeamCalendarEvent> {
    try {
        const response = await callUpdateTeamCalendarEvent(id, body);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function deleteTeamCalendarEvent(id: string, updatedBy: string): Promise<string> {
    try {
        const response = await callDeleteTeamCalendarEvent(id, updatedBy);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getTeamCalendarShareLinks(): Promise<TeamCalendarShareLink[]> {
    try {
        const response = await retrieveTeamCalendarShareLinks();
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function createTeamCalendarShareLink(
    body: TeamCalendarShareLinkCreateRequest
): Promise<TeamCalendarShareLink> {
    try {
        const response = await callCreateTeamCalendarShareLink(body);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function deleteTeamCalendarShareLink(
    id: string,
    updatedBy: string
): Promise<string> {
    try {
        const response = await callDeleteTeamCalendarShareLink(id, updatedBy);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getPublicTeamCalendar(
    shareToken: string,
    params?: TeamCalendarEventSearchRequest
): Promise<TeamCalendarPublicCalendarResponse> {
    try {
        const response = await retrievePublicTeamCalendar(shareToken, params);
        return validateDataResponse(response);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}
